import { render } from "./productsList.vue?vue&type=template&id=4c747e1b&scoped=true"
import script from "./productsList.vue?vue&type=script&lang=js"
export * from "./productsList.vue?vue&type=script&lang=js"

import "./productsList.vue?vue&type=style&index=0&id=4c747e1b&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c747e1b"]])

export default __exports__